import { render, staticRenderFns } from "./OrderListReturnAll.vue?vue&type=template&id=18904953&scoped=true"
import script from "./OrderListReturnAll.vue?vue&type=script&lang=js"
export * from "./OrderListReturnAll.vue?vue&type=script&lang=js"
import style0 from "./OrderListReturnAll.vue?vue&type=style&index=0&id=18904953&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18904953",
  null
  
)

export default component.exports